import React from "react";
import "./styles/tokens.css";
import "./styles/Page.css";

/**
 * Page shell. Replaces the `<main className="{prefix}-page">` wrapper
 * plus the loading/error blocks that every page repeated verbatim.
 *
 * The `accent` prop sets --rs-accent on this element only, so a single
 * value re-themes the H1, kickers, card icons, active chips and links
 * for the whole page.
 *
 * <Page accent="#4f5574" loading={!data} error={error}> … </Page>
 */
export default function Page({
  children,
  accent,
  theme,
  loading = false,
  error = null,
  loadingText = "Lädt…",
  errorText = "Inhalt konnte nicht geladen werden.",
  className = "",
}) {
  const style = accent ? { "--rs-accent": accent } : undefined;

  if (error) {
    return (
      <main className={`rs-page ${className}`} style={style} data-rs-theme={theme}>
        <div className="container rs-state">
          <p>{errorText}</p>
        </div>
      </main>
    );
  }

  if (loading) {
    return (
      <main className={`rs-page ${className}`} style={style} data-rs-theme={theme}>
        <div className="container rs-state">
          <p>{loadingText}</p>
        </div>
      </main>
    );
  }

  return (
    <main className={`rs-page ${className}`} style={style} data-rs-theme={theme}>
      {children}
    </main>
  );
}